<template>
  <div>
    <b-navbar type="light" variant="faded">
      <b-navbar-brand router-link to="/" exact>
        <h1 v-text="'Nestor'" />
      </b-navbar-brand>

      <b-nav class="text-nowrap" pills>
        <b-nav-item router-link to="/users" active-class="active">{{ $t('users') }}</b-nav-item>
        <b-nav-item router-link to="/licenses" active-class="active">{{ $t('licenses') }}</b-nav-item>
        <b-nav-item router-link to="/usage" active-class="active">{{ $t('usage') }}</b-nav-item>
        <b-nav-item router-link to="/orders" active-class="active">{{ $t('orders') }}</b-nav-item>
        <b-nav-item router-link to="/subscriptions" v-if="!isActiveProfileSet" active-class="active">{{ $t('subscriptions') }}</b-nav-item>
        <b-nav-item router-link to="/groups" active-class="active">{{ $t('groups') }}</b-nav-item>
        <b-nav-item router-link to="/organizations" active-class="active">{{ $t('organizations') }}</b-nav-item>
        <b-nav-item router-link to="/products" active-class="active">{{ $t('products') }}</b-nav-item>
        <b-nav-item router-link to="/eventlog" v-if="!isActiveProfileSet" active-class="active">{{ $t('eventLog') }}</b-nav-item>
        <b-nav-item router-link to="/reports" v-if="!isActiveProfileSet" active-class="active">{{ $t('reports') }}</b-nav-item>
      </b-nav>

      <b-navbar-nav class="ml-auto aco-active-display" right v-if="isActiveProfileSet">
        <b-nav-text>
          {{ $t('active') }}: {{ activeProfile.name }}
          <b-icon-x-circle-fill scale="1.25" shift-h="4" variant="danger" v-on:click="clearSessionStorage()"></b-icon-x-circle-fill>
        </b-nav-text>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto" right>
        <b-nav-item-dropdown right :text="$t('language')">
          <b-dropdown-item @click="changeLocale('nb')">{{ $t('languages.norwegian') }}</b-dropdown-item>
          <b-dropdown-item @click="changeLocale('en')">{{ $t('languages.english') }}</b-dropdown-item>
        </b-nav-item-dropdown>
        <div v-if="oidcUser">
          <span id="username" v-text="oidcUser.username" />
        </div>
      </b-navbar-nav>
    </b-navbar>

    <router-view/>
  </div>
</template>

<script>
  import i18n from './plugins/vue-i18n'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'App',
    data: function () {
      return {
        baseUrl: process.env.BASE_URL
      }
    },
    computed: {
      ...mapGetters('oidcStore', ['oidcUser']),
      ...mapGetters('sessionStorage', ['isActiveProfileSet', 'activeProfile']),
    },
    methods: {
      ...mapActions('oidcStore', ['signOutOidc']),
      ...mapActions('sessionStorage', ['clearSessionStorage']),
      changeLocale (locale) {
        i18n.locale = locale
        this.$store.dispatch('languageStore/changeLanguage', locale)
      },
      userLoaded: function (e) {
        if (process.env.NODE_ENV === 'development') {
          console.log('Loaded user using vuex-oidc', e.detail)
        }
      },
      showError: function (reason) {
        if (reason.ignore) {
          console.log('Ignoring error with message: ' + reason.message)
          return
        }

        // Axios errors have a response object with more details about what failed
        let message = reason.message
        if (reason.response && reason.response.headers && reason.response.headers['content-type'] === 'application/json') {
          message = 'Server returned status ' + reason.response.status + ' ' + reason.response.data.error + ': ' + reason.response.data.message
        }

        this.$bvToast.toast(message, {
          title: this.$t('errorOccurred'),
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 10000
        })
      }
    },
    mounted () {
      document.body.classList.add('bg-light')
      window.addEventListener('vuexoidc:userLoaded', this.userLoaded)
      window.addEventListener('unhandledrejection', event => {
        this.showError(event.reason)
      })
      this.$store.dispatch('sessionStorage/checkSessionStorage')
      this.$store.dispatch('sessionStorage/updateState')
    },
    destroyed () {
      window.removeEventListener('vuexoidc:userLoaded', this.userLoaded)
      window.removeEventListener('unhandledrejection', event => {
        this.showError(event.reason)
      })
    }
  }
</script>

<style lang="scss">
@import 'assets/custom.scss';
@import '~bootstrap/scss/bootstrap.scss';
@import '~bootstrap-vue/src/index.scss';

#username {
  display: inline-block;
  padding: 8px;
}
</style>
